// Address and search helpers used across the app
export type AddressParts = {
  neighborhood?: string;
  street?: string;
  buildingInfo?: string;
  floor?: string;
};

// Display full address without commas, using spaces
export const formatAddressParts = (addr: AddressParts) => {
  return [
    addr.neighborhood?.trim(),
    addr.street?.trim(),
    addr.buildingInfo?.trim(),
    addr.floor?.trim() ? `Kat: ${addr.floor!.trim()}` : ''
  ]
    .filter(Boolean)
    .join(' ');
};

// Normalize queries/fields to ignore punctuation and collapse spaces
export const normalizeQuery = (s: string) =>
  (s || '')
    .toLowerCase()
    .replace(/[.,;:/\\-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
